import { render, staticRenderFns } from "./DetailPageNav.vue?vue&type=template&id=c4d55d4a&"
import script from "./DetailPageNav.vue?vue&type=script&lang=js&"
export * from "./DetailPageNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports